import { useEffect, useRef, useState } from "react";
export default function Image(rest){
    const [load, setload] = useState(false)
    const ref = useRef(null)

    // src değişince gizle; ayrıca cache'ten anında gelen resimlerde onLoad
    // handler bağlanmadan önce load olayı geçebilir → complete ile yakala.
    useEffect(()=>{
        setload(false)
        const img = ref.current
        if(img && img.complete && img.naturalWidth > 0) setload(true)
    },[rest.src])

    // visibility (display değil): loading="lazy" display:none'da kutu oluşmadığı için resmi hiç yüklemez
    return (
        <img loading="lazy" decoding="async" {...rest} ref={ref} onLoad={()=> setload(true)}
             style={{ ...(rest.style||{}), display: 'inline-block', visibility: load ? 'visible' : 'hidden' }}/>
    )
}
